import spriteContent from './_sprites_svg.svg'
import spriteSyncContent from './_sprites_sync.svg'
const div = document.createElement('div')
div.style.display = 'none'
div.innerHTML = spriteContent
div.id = 'sprite-content'
document.body.appendChild(div)

const divSync = document.createElement('div')
divSync.style.display = 'none'
divSync.innerHTML = spriteSyncContent
divSync.id = 'sprite-sync'
document.body.appendChild(divSync)
